import type { IllustrationCollection } from "../types/IllustrationType";

/**
 * Illustration configuration mapping names to their file paths
 */
export const illustrations: IllustrationCollection = {
  advisor: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 11,
        top: 17,
      },
      rotation: 0,
      size: 36,
    },
  },
  advisorChill: {},
  advisorCompliant: {},
  advisorGrowth: {},
  calculate: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 31.5,
        top: 22.5,
      },
      rotation: -1,
      size: 35,
    },
  },
  calculation: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 24.2,
        top: 10,
      },
      animations: {
        hoverDirection: "right",
      },
      rotation: -4,
      size: 37,
    },
  },
  calculating: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 22,
        top: 12,
      },
      rotation: 4,
      size: 34,
    },
  },
  certificate: {
    head: {
      face: "smile",
      direction: "left",
      position: {
        left: 19.5,
        top: 6,
      },
      animations: {
        hoverDirection: "right",
      },
      rotation: -4,
      size: 42,
    },
  },
  dashboard: {
    head: {
      face: "none",
      direction: "left",
      position: {
        left: 12,
        top: 13,
      },
      rotation: 9,
      size: 38,
    },
  },
  default: {
    head: {
      face: "smile",
      direction: "left",
      position: {
        left: 37,
        top: 14,
      },
      animations: {
        hoverDirection: "right",
      },
      rotation: -9,
      size: 36,
    },
  },
  houseAnalysis: {
    head: {
      face: "smile",
      direction: "left",
      position: {
        left: 56,
        top: 6.4,
      },
      rotation: -6,
      size: 38,
      index: 0,
    },
  },
  houseLove: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 35,
        top: 34,
      },
      rotation: 0,
      size: 34,
    },
  },
  houseScan: {
    head: {
      face: "smile",
      direction: "left",
      position: {
        left: 53,
        top: 7,
      },
      rotation: 2,
      size: 38,
    },
  },
  housesThought: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 34.5,
        top: 27,
      },
      rotation: -2,
      size: 34,
      index: 0,
    },
  },
  interest: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 30.5,
        top: 14,
      },
      rotation: -3,
      size: 38,
    },
  },
  interestThought: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 21,
        top: 8,
      },
      rotation: -3,
      size: 40,
    },
  },
  phoneContact: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 12,
        top: 9,
      },
      rotation: -1,
      size: 32,
      index: 0,
    },
  },
  together: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 12,
        top: 19.5,
      },
      rotation: -3,
      size: 31,
    },
  },
  maintenance: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 30,
        top: 14,
      },
      rotation: -3,
      size: 35,
    },
  },
  myHouse: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 18,
        top: 13,
      },
      rotation: -3,
      size: 35,
    },
  },
  refinance: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 18,
        top: 14,
      },
      rotation: -3,
      size: 35,
    },
  },
  building: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 14,
        top: 12,
      },
      rotation: -8,
      size: 34,
    },
  },
  notFound: {
    head: {
      face: "smile",
      direction: "right",
      position: {
        left: 17,
        top: 19,
      },
      rotation: -2,
      size: 36,
    },
  },
  shrug: {
    head: {
      face: "smile",
      direction: "left",
      position: {
        left: 29,
        top: 20,
      },
      rotation: 0,
      size: 36,
    },
  },
  living: {},
  outside: {},
  price: {},
  neighbourhood: {},
  kitchen: {},
  sun: {},
  technology: {},
  materials: {},
  clipboard: {},
  map: {},
  foundation: {},
};
